<template>
    <!-- 我们是谁  -->
     <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'about',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--50.png",
        }
    },
    computed: {
        title() {
            return this.$t('about.title');
        },
        subtitle() {
            return this.$t('about.subtitle');
        },
        description() {
            return this.$t('about.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    },
}
</script>